module.exports = __webpack_public_path__ + "img/noConfig.e9fb42bb.png";